import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, umsUrl } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { FAB_SURGE_UPDATE_USER_ROLE, FAB_SURGE_UPDATE_USER_ROLE_ERROR, FAB_SURGE_UPDATE_USER_ROLE_SUCCESS } from '../../../actions.js';

function* updateFabUserRole({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/attach-user-roles`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FAB_SURGE_UPDATE_USER_ROLE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: FAB_SURGE_UPDATE_USER_ROLE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FAB_SURGE_UPDATE_USER_ROLE_ERROR, payload: error });
  }
}

export function* watchUpdateFabUserRole() {
  yield takeEvery(FAB_SURGE_UPDATE_USER_ROLE, updateFabUserRole);
}

function* updateFabUserRoleSaga() {
  yield all([fork(watchUpdateFabUserRole)]);
}

export default updateFabUserRoleSaga;
